import { Injectable } from "@angular/core";

import { RegistrationFeatureState } from "../../state";
import { RegistrationResponse } from "../registration.model";

@Injectable({
	providedIn: "root",
})
export class RegistrationWithSPIDSelector {
	spIdAuthorizationUrl() {
		return (state: RegistrationFeatureState): string | undefined =>
			state.registrationFeature.registrationWithSPID.spIdAuthorizationUrl;
	}

	getSPIDAuthorizationUrlSuccess() {
		return (state: RegistrationFeatureState): boolean | undefined =>
			state.registrationFeature.registrationWithSPID.getSPIDAuthorizationUrlSuccess;
	}

	spIdJwtToken() {
		return (state: RegistrationFeatureState): string | undefined =>
			state.registrationFeature.registrationWithSPID.spIdJwtToken;
	}

	getSPIDJwtTokenSuccess() {
		return (state: RegistrationFeatureState): boolean | undefined =>
			state.registrationFeature.registrationWithSPID.getSPIDJwtTokenSuccess;
	}

	getSPIDRegistrationToken() {
		return (state: RegistrationFeatureState): RegistrationResponse | undefined =>
			state.registrationFeature.registrationWithSPID.registrationToken;
	}

	getSPIDRegistrationTokenSuccess() {
		return (state: RegistrationFeatureState): boolean | undefined =>
			state.registrationFeature.registrationWithSPID.getRegistrationTokenSuccess;
	}
}
